module.exports = __webpack_public_path__ + "static/media/paramLogo_02.b02ba79a.svg";